import {
  Box
} from "@chakra-ui/react";

export default function ContentCard({
  children
}: any) {

  return (

    <Box
      bg="white"
      p={6}
      borderRadius="16px"
      boxShadow="sm"
      border="1px solid #E2E8F0"
    >
      {children}
    </Box>

  );
}